import axios from '@util/axios'

class TokenService {
  async verifyToken(token) {
    return await axios.post('/auth/token/verify/', {
      token
    })
  }
}

export default new TokenService()
